// orderEditActions.js
import {
  ADD_TO_ORDER,
  CLEAR_ORDER,
  DOWNGRADE_ORDER_ITEM_QUANTITY,
  REMOVE_FROM_ORDER,
  UPDATE_ORDER_ITEM_DISCOUNT,
  UPDATE_ORDER_ITEM_QUANTITY,
  UPDATE_ORDER_ITEM,
  UPDATE_ORDER_ITEM_VOID,
  UPDATE_ORDER_ITEM_REFUND,
  SET_ORDER_DATA,
  UPDATE_ORDER_ITEM_INSTRUCTIONS,
} from './types';

export const AddToOrder = (item) => {
  if (!item) {
    console.error('AddToOrder: item is required');
    return { type: 'INVALID_ACTION' };
  }
  return {
    type: ADD_TO_ORDER,
    payload: item,
  };
};

export const RemoveFromOrder = (itemData, index) => ({
  type: REMOVE_FROM_ORDER,
  payload: { itemData, index },
});

export const updateOrderItemQuantity = (index, itemId) => ({
  type: UPDATE_ORDER_ITEM_QUANTITY,
  payload: { index, itemId },
});

export const updateOrderItem = (index, itemId, updates) => ({
  type: UPDATE_ORDER_ITEM,
  payload: { index, itemId, updates },
});

export const downgradeOrderItemQuantity = (index, itemId) => ({
  type: DOWNGRADE_ORDER_ITEM_QUANTITY,
  payload: { index, itemId },
});

export const updateOrderItemVoid = (index, itemId, voidStatus) => ({
  type: UPDATE_ORDER_ITEM_VOID,
  payload: { index, itemId, voidStatus },
});

export const updateOrderItemRefund = (index, itemId, refundStatus) => ({
  type: UPDATE_ORDER_ITEM_REFUND,
  payload: { index, itemId, refundStatus },
});

export const clearOrder = () => ({
  type: CLEAR_ORDER,
});

export const updateOrderDiscount = (index, itemId, discount, selectedPromotionDetails, discountType, discountId, promotionId) => ({
  type: UPDATE_ORDER_ITEM_DISCOUNT,
  payload: { index, itemId, discount, selectedPromotionDetails, discountType, discountId, promotionId },
});

export const setOrderData = (orderData) => {
  if (!Array.isArray(orderData)) {
    console.error('setOrderData: orderData must be an array');
    return { type: 'INVALID_ACTION' };
  }
  return {
    type: SET_ORDER_DATA,
    payload: orderData,
  };
};

export const updateOrderItemInstructions = (index, itemId, instructions) => ({
  type: UPDATE_ORDER_ITEM_INSTRUCTIONS,
  payload: { index, itemId, instructions },
});
